module.exports = __webpack_public_path__ + "media/images/athletes/4701-5ea892e7ebd2a65bb5f3415fe6522fc4.png";